import React from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TUpdateDiscountStatusReduxParams, TUpdateInventoryTransactionStatusReduxParams } from '~types/feat/approval';

import { TransactionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import * as Styles from './_confirmUpdateDiscountStatusModal.module.scss';

const ConfirmUpdateDiscountStatusModal = () => {
    const isOpen = useAppSelector(state => state.approval.modals.confirmUpdateDiscountStatusModalIsOpen);
    const tempUpdateDiscountState = useAppSelector(state => state.approval.tempUpdateDiscountState);
    const isLoading = useAppSelector(state => state.approval.loadings.updateDiscountStatus);
    const error = useAppSelector(state => state.approval.errors.updateDiscountStatus);

    const getStatus = () => {
        switch (tempUpdateDiscountState.status) {
            case (TransactionStatusEnum.Approved): return 'Approve';
            case (TransactionStatusEnum.Rejected): return 'Reject';
            default: return '';
        }
    };

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmUpdateDiscountStatusModalIsOpen(open));
    const updateDiscountStatus = (data: TUpdateDiscountStatusReduxParams) => dispatch(combinedActions.approvalUpdateDiscountStatusAttempt(data));

    const handleSubmitClick = () => {
        updateDiscountStatus(tempUpdateDiscountState);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        (getStatus() === 'Approve' ? Styles['confirm-approve'] : ''),
        (getStatus() === 'Reject' ? Styles['confirm-reject'] : ''),
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.approvalResetUpdateDiscountStatusState());
        }

        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm ${getStatus()} Discount?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    label={getStatus()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                    disabled={isLoading}
                />
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmUpdateDiscountStatusModal;
